export enum DEVICES {
	MOBILE = 'mobile',
	TABLET = 'tablet',
	DESKTOP = 'desktop',
}
